export default "__VITE_ASSET__BgOpbY8I__"